<template>
	<LayoutForm>
		<h1 slot="header">Member Setup</h1>

		<FormStepNav slot="nav" :total-steps="totalSteps" :current-step="currentStep"
		             :completed-step="completedStep" :route-base="routeBase">
		</FormStepNav>

		<MemberFormStep1 type="create" v-if="currentStep === 1"></MemberFormStep1>
		<MemberFormStep2 v-if="currentStep === 2"></MemberFormStep2>
		<MemberFormStep3 v-if="currentStep === 3"></MemberFormStep3>
	</LayoutForm>
</template>

<script>
	import LayoutForm from '../Layout/LayoutForm';
	import FormStepNav from '../Form/FormStepNav';
	import MultiStepForm from '../Form/MultiStepForm';
	import MemberFormStep1 from './MemberForm/MemberFormStep1';
	import MemberFormStep2 from './MemberForm/MemberFormStep2';
	import MemberFormStep3 from './MemberForm/MemberFormStep3';
    import API from '../../api';

	export default {
		name: 'MemberCreateForm',
		mixins: [MultiStepForm],
		components: {
			MemberFormStep1,
			MemberFormStep2,
			MemberFormStep3,
			FormStepNav,
			LayoutForm
		},
        methods: {
            fetchResource(id) {
                return API.getMember(id);
            },
            sanitizeResource(member) {
                console.log("Member: ", member);
                console.log("Form data: ", this.formData);
                if(member.hq) {
                    if(member.hq.country) {
                        member.hqCountry = member.hq.country.id;
                        member.region = member.hq.country.region_id;
                    }

                    if(member.hq.location) {
                        member.hqLocation = member.hq.location;
                    }

                    if(member.hq.address_line_1) {
                        member.hqAddressLine1 = member.hq.address_line_1;
                    }

                    if(member.hq.address_line_2) {
                        member.hqAddressLine2 = member.hq.address_line_2;
                    }

                    if(member.hq.address_line_3) {
                        member.hqAddressLine3 = member.hq.address_line_3;
                    }

                    if(member.hq.telephone) {
                        member.telephone = member.hq.telephone;
                    }
                }

                let offices = [];
                if(member.offices && Array.isArray(member.offices)) {
                    member.offices.forEach(office => {
                        if(office.country && office.location) {
                            let officeObj = {
                                country: office.country.id,
                                location: office.location,
                                id: office.id,
                            }

                            if(office.address_line_1) {
                                officeObj.address_line_1 = office.address_line_1;
                            }

                            if(office.address_line_2) {
                                officeObj.address_line_2 = office.address_line_2;
                            }

                            if(office.address_line_3) {
                                officeObj.address_line_3 = office.address_line_3;
                            }

                            if(office.telephone) {
                                officeObj.telephone = office.telephone;
                            }

                            offices.push(officeObj);
                        }
                    })
                }
                member.offices = offices;

                member.logoUrl = `/images/logo/${member.id}`;

                if(member.logo && member.logo.uuid) {
                    member.logo = member.logo.uuid;
                }

                return member;
            }
        },
		data() {
			return {
				totalSteps: 3,
				routeBase: (this.id) ? `/members/${ this.id }/edit` : '/members/create',
			}
		}
	}
</script>
